import Button from "../../../components/Button/Button";
import type { ListItemBlock } from "../../schema/blocks/list-item";

type ListItemOptionsProps = {
    block: ListItemBlock;
    onChange: (block: ListItemBlock) => void;
};

export default function ListItemOptions(props: ListItemOptionsProps) {
    const { block, onChange } = props;
    return (
        <Button
            label={block.ordered ? "Passer en puces" : "Passer en liste numérotée"}
            action={() => onChange({ ...block, ordered: !block.ordered })}
            feeling="minor"
            role="minor"
            size="small"
        />
    );
}
